import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getShouldCostBreakdownDetailsAsync, getIfaTrendsLineChartDataAsync } from 'src/services/shouldCostAIBased.services'

const initialState = {
  shouldCostModelDetailsLoader: false,
  shouldCostModelDetailsError: '',
  shouldCostModelDetails:{},
  creationSource: null,
}

export const shouldCostModelDetailsSlice = createSlice({
  name: 'shouldCostModelDetails',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getShouldCostBreakdownDetailsAsync.pending), (state) => {
      state.shouldCostModelDetailsLoader = true
    })
    builder.addMatcher(isAnyOf(getShouldCostBreakdownDetailsAsync.fulfilled), (state, action) => {
      state.shouldCostModelDetailsLoader = false
      state.shouldCostModelDetails = {...state.shouldCostModelDetails, 
        bill_of_material: action.payload.data.bill_of_material,
        chart_cost_summary: action.payload.data.chart_cost_summary
      }
      state.shouldCostModelDetailsError = ''
      state.creationSource = action.payload.data.creation_source
    })
    builder.addMatcher(isAnyOf(getShouldCostBreakdownDetailsAsync.rejected), (state, action) => {
      state.shouldCostModelDetailsLoader = false
    })
    builder.addMatcher(isAnyOf(getIfaTrendsLineChartDataAsync.pending), (state) => {
      state.shouldCostModelDetailsLoader = true
    })
    builder.addMatcher(isAnyOf(getIfaTrendsLineChartDataAsync.fulfilled), (state, action) => {
      state.shouldCostModelDetailsLoader = false
      state.shouldCostModelDetails = {...state.shouldCostModelDetails, mini_ifa:action.payload.data.mini_ifa}
      state.shouldCostModelDetailsError = ''
      state.creationSource = action.payload.data.creation_source
    })
    builder.addMatcher(isAnyOf(getIfaTrendsLineChartDataAsync.rejected), (state, action) => {
      state.shouldCostModelDetailsLoader = false
    })
  },
  reducers: {
    emptyshouldCostModelDetailsSlice: (state) => {
      state.shouldCostModelDetailsLoader = false
      state.shouldCostModelDetailsError = ''
      state.shouldCostModelDetails = {}
      state.creationSource = null
    },
  },
})

export const { emptyshouldCostModelDetailsSlice } = shouldCostModelDetailsSlice.actions

export default shouldCostModelDetailsSlice.reducer
